export default __webpack_public_path__ + "static/media/marker_active.67d8b34e.svg";